import React from 'react';
import BondSectionTemplate from './BondSectionTemplate';
import { cn } from '@ui/atoms/utils/utils';

const PricingMasked = () => {
    return (
        <BondSectionTemplate
            title={'Pricing Details'}
            className="xl:max-w-[744px] border-b-0"
        >
            <div
                className={cn(
                    `flex gap-10 items-center w-full rounded-b-lg flex-wrap pt-6 md:pt-0`
                )}
            >
                <div className="flex flex-col w-full gap-2 max-w-[135px]">
                    <div className="w-3/4 h-3 bg-gray-100 rounded" />
                    <div className="w-full h-3 bg-gray-100 rounded" />
                </div>
                <div className="flex flex-col w-full gap-2 max-w-[135px]">
                    <div className="w-3/4 h-3 bg-gray-100 rounded" />
                    <div className="w-full h-3 bg-gray-100 rounded" />
                </div>
                <div className="flex flex-col w-full gap-2 max-w-[135px]">
                    <div className="w-3/4 h-3 bg-gray-100 rounded" />
                    <div className="w-full h-3 bg-gray-100 rounded" />
                </div>
                <div className="flex flex-col w-full gap-2 max-w-[135px]">
                    <div className="w-3/4 h-3 bg-gray-100 rounded" />
                    <div className="w-full h-3 bg-gray-100 rounded" />
                </div>
            </div>
        </BondSectionTemplate>
    );
};

export default PricingMasked;
